import { PlanTier } from '@shared/price-plan/enums';

export const PLAN_TIERS: Record<number, string> = {
  [PlanTier.free]: 'Free',
  [PlanTier.premium]: 'Premium',
  [PlanTier.starter]: 'Starter',
  [PlanTier.business]: 'Business',
};
